import React, { Component } from "react"
import TableFiscais from "./TableFiscais"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
import Layout from "../Layout"
export default class Fiscais extends Component {
  constructor() {
    super()
    this.getFiscais = this.getFiscais.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { fiscais: [], initialFiscais: [], showTable: false }
  }
  componentWillMount() {
    this.getFiscais()
  }
  getFiscais() {
    ApiHelper.getFiscais((fiscais, error) => {
      if (fiscais) {
        this.setState({
          fiscais: fiscais,
          initialFiscais: fiscais,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  didDelete() {
    this.getFiscais()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialFiscais.filter(fiscal => {
      return (
        fiscal.name.toLowerCase().search(searchText) !== -1 ||
        fiscal.cpf.toLowerCase().search(searchText) !== -1 ||
        fiscal.email.toLowerCase().search(searchText) !== -1 ||
        fiscal.unidade_orcamentaria[0].uni_orc
          .toLowerCase()
          .search(searchText) !== -1
      )
    })
    this.setState({
      fiscais: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscais de contrato">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscais de contrato">
        {this.state.showTable ? (
          <TableFiscais
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title="Fiscais de contrato"
            subtitle="Listagem de todos os fiscais de contrato"
            backgroundColor="as-blue"
            rows={this.state.fiscais}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscais/Fiscais.js